export const __passedThroughComposition = Symbol('__passedThroughComposition');

//# sourceMappingURL=rootQuery.js.map